import Component from '../core/Component'
import withMedia from '../core/withMedia'
import Scroll from '../services/Scroll'

class Cards extends Component {
    constructor(element) {
        super(element)

        const color = this.element.dataset.color

        this.ref = {
            cards: [],
            containers: [],
            width: null,
        }

        this.state = {
            scale: 0,
            scaling: false,
            start: 0,
            end: 0,
            range: 0,
        }

        this.color = null

        if (color) {
            this.color = color
        }

        this.visualHeaderBottom = null
    }

    prepare() {
        const visualHeader = document.querySelector('.VisualHeader')
        if (visualHeader) {
            const visualHeaderRect = visualHeader.getBoundingClientRect()
            this.visualHeaderBottom = visualHeaderRect.bottom + Scroll.getScroll().y
        }

        this.cards = this.ref.cards.map((element) => ({
            element,
            start: 0,
            end: 0,
            height: 0,
        }))
        Scroll.on('resize', this.handleResize)
        Scroll.on('scroll', this.handleScroll)
        this.resize()
    }

    destroy() {
        Scroll.off('resize', this.handleResize)
        Scroll.off('scroll', this.handleScroll)
        this.ref.cards.forEach((element) => element.removeAttribute('style'))
        this.element.removeAttribute('style')
    }

    handleResize = () => {
        this.resize()
    }

    handleScroll = ({ offset }) => {
        this.render(offset.y)
    }

    resize() {
        const { y } = Scroll.getScroll()
        const boxes = this.cards.map((card) => card.element.getBoundingClientRect())
        const cardHeight = this.element.querySelector(".CardCategory-header").offsetHeight

        let remainingLength = boxes
            .map((box) => box.height)
            .filter((item, index) => index < this.cards.length - 1)
            .reduce((acc, item) => acc + item, 0)

        let cumulativeOffset = 0;

        this.cards.forEach((item, index) => {
            const previousItem = index > 0 ? this.cards[index - 1] : null
            const previousBox = index > 0 ? boxes[index - 1] : null
            const box = boxes[index]

            let topEdgeAlignment = this.visualHeaderBottom || 0

            if (previousItem) {
                topEdgeAlignment = previousItem.start + previousBox.height - (cardHeight - 1)
            }

            const bottomEdgeAlignment = y + box.top + box.height - window.innerHeight - cumulativeOffset
            cumulativeOffset += box.height

            const start = Math.max(bottomEdgeAlignment, topEdgeAlignment)
            const end = start + remainingLength - (this.cards.length - 1 - index) * (cardHeight - 1)
            remainingLength -= box.height

            item.start = start
            item.end = end
        })

        const cardWidth = Math.max(
            ...this.ref.containers.map((element) => element.getBoundingClientRect().width),
        )
        const containerWidth = this.ref.width.getBoundingClientRect().width

        const footerHeight = document.getElementById('footer')?.getBoundingClientRect()?.height || 0

        this.state.scale = cardWidth / containerWidth
        this.state.start = Math.max(...this.cards.map((item) => item.end))
        this.state.range = footerHeight
        this.state.end = this.state.start + this.state.range
    }


    render(y) {
        const maxOpacity = 0.2
        const step = maxOpacity / (this.cards.length - 1)

        this.cards.forEach((card, index) => {
            if (index === this.cards.length - 1) {
                return
            }

            card.element.style.transform = `translateY(${Math.max(
                0,
                Math.min(y, card.end) - card.start,
            )}px)`

            if (this.color) {
                console.log(this.color)
                const progress = Math.min(1, Math.max(0, (y - card.start) / (card.end - card.start)))
                const container = card.element.querySelector(".Container")

                const overlayOpacity = (this.cards.length - index - 1) * step * progress
                container.style.backgroundColor = `rgba(${this.color}, ${overlayOpacity})`
            }
        })

        if (y > this.state.start && y < this.state.end) {
            const factor = this.state.scale - 1
            this.element.style.transform = `scale(${
                1 / ((Math.abs(this.state.start - y) / this.state.range) * factor + 1)
            })`
            this.state.scaling = true
        }

        if (y < this.state.start && this.state.scaling) {
            this.state.scaling = false
            this.element.style.transform = 'scale(1)'

        }

        if (y > this.state.end && this.state.scaling) {
            this.state.scaling = false
            this.element.style.transform = `scale(${1 / this.state.scale})`

        }
    }
}

export default withMedia(Cards)
